export default "__VITE_ASSET__CoCTSQxf__"